import React, { useEffect } from "react";
import { useSelector } from "react-redux";

import { Button, H1, Text } from "@salt-ds/core";

import store, { RootState } from "src/store/store";

import NotificationBanner from "src/app/NotificationBanner";

import { openEmailClient } from "src/utils/UtilityFunction";
import {
  ACH_THANKS_CONTACT_DESCRIPTION,
  ACH_THANKS_H1,
  ACH_THANKS_PARTIAL_SUCCESS_H1,
  ACH_THANKS_TEXT_DESCRIPTION,
  CONTACTUS,
} from "src/utils/Constants";

const ThanksForEnroll: React.FC = () => {
  const { status } = useSelector((state: RootState) => state.buyerStatus);

  const secData = useSelector(
    (state: ReturnType<typeof store.getState>) => state.getSecData.value
  );

  const contentTargetEnrollment =
    secData?.secDataDetails?.content?.contentTargetEnrollment;

  const mailtoLink = openEmailClient(contentTargetEnrollment);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="w-[684px] h-[288px] mx-auto flex items-center justify-center">
      <div className=" flex-col  justify-center gap-10 inline-flex mt-[35px]">
        <div className=" bg-white flex-col justify-start items-start gap-6 inline-flex">
          <div className="  flex-col justify-start  inline-flex ">
            {status === "SUCCESS" && <H1>{ACH_THANKS_H1}</H1>}
            {status === "PARTIAL SUCCESS" && (
              <H1>{ACH_THANKS_PARTIAL_SUCCESS_H1}</H1>
            )}

            {status === "PARTIAL SUCCESS" && (
              <div className="mt-[24px]">
                <NotificationBanner />
              </div>
            )}

            {!status && (
              <H1>
                Your enrollment process is complete as per the status reported
                earlier.
              </H1>
            )}

            <div className=" flex-col justify-start items-start  inline-flex mt-[24px] w-auto">
              <Text>{ACH_THANKS_TEXT_DESCRIPTION}</Text>

              <Text className="mt-[24px]">
                {ACH_THANKS_CONTACT_DESCRIPTION}
              </Text>
            </div>
          </div>
        </div>
        <div className=" py-[5px] rounded-[3px] justify-start items-center inline-flex">
          <Button
            onClick={() => (window.location.href = mailtoLink)}
            variant="cta"
            className="bg-customBlue rounded text-white normal-case"
          >
            {CONTACTUS}
          </Button>
        </div>
      </div>
    </div>
  );
};
export default ThanksForEnroll;
